export const BITACORA = {
  newButton: 'bitacora-new-button',
  list: 'bitacora-list',
  row: 'bitacora-row',
  deleteButton: 'bitacora-delete-button',
  formSubmit: 'bitacora-form-submit',
  formCancel: 'bitacora-form-cancel',
};
